var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',[_c('v-container',[_c('v-col',{attrs:{"lg":"12","xl":"12"}},[_c('v-card',{staticClass:"ma-2",attrs:{"elevation":"5"}},[_c('v-col',[_c('v-row',[_c('DashInfo')],1)],1),_c('v-row',[_c('v-col',[_c('DashGraphic')],1),_c('v-col',[_c('DashOperations')],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }